var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M975.5,693.3c-0.4,0.4-0.9,0.9-1.3,1.3c-135,135-357.5,129.5-485.3-16.8c-107.6-123.2-108.3-310.1-1.6-434.1 c5.9-6.8,12-13.3,18.2-19.6c29.3-29.1-1.5-77.3-40.6-64.2c-70.4,23.7-136,65.2-190,124.4c-161.6,177.2-155,454.6,14.2,624.5 c176.9,177.5,464.1,177.7,641.2,0.6c51.7-51.7,88.2-112.7,109.7-177.6C1052.9,693,1004.3,664.2,975.5,693.3L975.5,693.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNights);
export default __webpack_public_path__ + "static/media/Nights.2b86d07a438a126012de8ef05613a749.svg";
export { ForwardRef as ReactComponent };